import styled from 'styled-components'

export const SimpleSuccessModalContainer = styled.div`
  width: 100%;

  button {
    width: 100%;
    border-radius: 9999px;
    border-color: #4b4b4b;
    color: #4b4b4b;

    &:hover {
      background-color: #f6f6f6;
    }
  }
`

export const HeaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 20px;
`